import React from "react";
import InquiryToCustomer from "../../../components/Serviceworld/InquiryToCustomer/InquiryToCustomer";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";

export default function InquiryToCustomerPage() {
  return (
    <LayoutAuthenticated>
      <InquiryToCustomer />
    </LayoutAuthenticated>
  );
}
